import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Monitor, Copy, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

export const pcHintSeenKey = (email) => `il_pc_hint_seen_${email || ""}`;
// Iter 146: mostrata solo a chi entra da telefono (schermo stretto o app Android)
export const shouldShowPcHint = () => window.innerWidth < 768 || /Android/i.test(navigator.userAgent || "");

export function PcAccessHintDialog({ open, onClose }) {
  const url = window.location.origin;
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch { /* fallback sotto */ }
    setCopied(true);
    toast.success("Link copiato");
    setTimeout(() => setCopied(false), 2500);
  };
  const share = () => navigator.share({ title: "IL-Report", text: "Entra in IL-Report anche dal PC, stesse email e password:", url }).catch(() => {});

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="pc-access-hint-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Monitor className="h-5 w-5 text-[#0044FF]" /> Puoi usarmi anche dal PC
          </DialogTitle>
          <DialogDescription>
            Stesso indirizzo, stesse email e password dell'app. Inquadra il QR con la fotocamera o copia il link.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-3">
          <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid="pc-access-hint-qr">
            <QRCodeSVG value={url} size={168} level="M" />
          </div>
          <a href={url} target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-[#0044FF] underline break-all text-center" data-testid="pc-access-hint-url">{url}</a>
          <div className="flex gap-2 w-full">
            <Button variant="outline" onClick={copy} className="flex-1 h-11" data-testid="pc-access-hint-copy">
              {copied ? <Check className="h-4 w-4 mr-1.5 text-emerald-600" /> : <Copy className="h-4 w-4 mr-1.5" />} {copied ? "Copiato" : "Copia link"}
            </Button>
            {typeof navigator !== "undefined" && navigator.share && (
              <Button variant="outline" onClick={share} className="flex-1 h-11" data-testid="pc-access-hint-share">
                <Share2 className="h-4 w-4 mr-1.5" /> Invia
              </Button>
            )}
          </div>
          <Button onClick={onClose} className="w-full h-11 bg-[#0044FF] hover:bg-[#0033CC]" data-testid="pc-access-hint-close">Ho capito</Button>
          <div className="text-[11px] text-slate-400">Lo ritrovi sempre in Home, nel riquadro "Apri nel browser".</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
